import { jsx as _jsx } from "react/jsx-runtime";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
const { socials: { GET_SOCIALS_AI_INSTRUCTIONS } } = queries;
const { socials: { SOCIALS_AI_INSTRUCTION_DELETE } } = mutations;
const aiInstructionsList = () => (_jsx(List, { deleteMutation: SOCIALS_AI_INSTRUCTION_DELETE, itemNamePlural: "ai-instructions", label: "Ai Instructions", listQuery: GET_SOCIALS_AI_INSTRUCTIONS, listQueryDataName: "getSocialsAiInstructions", pathPrefix: "/socials" }));
export default aiInstructionsList;
